import { useAlgoliaCategories } from "@components/search/hooks/useAlgoliaCategories";
import {
  useHierarchicalMenu,
  useRange,
  useRefinementList,
  useSortBy,
} from "react-instantsearch";

export default function AlgoliaVirtualFilters() {
  const algoliaCategories = useAlgoliaCategories();

  useSortBy({
    items: [
      { label: "Price (asc)", value: "products_price_asc" },
      { label: "Price (desc)", value: "products_price_desc" },
    ],
  });
  useHierarchicalMenu({
    attributes: algoliaCategories,
  });
  useRefinementList({ attribute: "brand" });
  useRefinementList({ attribute: "size" });
  useRefinementList({ attribute: "colorsNormalized" });
  useRefinementList({ attribute: "gender" });
  useRange({ attribute: "minVariantTargetPrice" });
  return <></>;
}
